import { IOffer } from "../interface/IOffer";

export interface IOfferResponse {
    description: string;
    monthlyAmount: number;
    name: string;
}

export interface IOfferDetailsResponse {
    customerOfferDTO: IOfferResponse;
}

export interface ISimCardResponse {
    servideId: number;
    pin1Code: string;
    puk1Code: string;
    imsiNumber: number;
}

export interface ISimCard {
    pin: string;
    puk: string;
}

export const getResponseToStateCustomerOffer = (offerDetailsResponse: IOfferDetailsResponse): IOffer => ({
    description: offerDetailsResponse.customerOfferDTO.description,
    monthlyAmount: offerDetailsResponse.customerOfferDTO.monthlyAmount,
    name: offerDetailsResponse.customerOfferDTO.name,
});

export const getResponseToStateSimCard = (simCardResponse: ISimCardResponse) => ({
    pin: simCardResponse.pin1Code,
    puk: simCardResponse.puk1Code,
});
